<div class="di-convention">
	<div class="container">
		<div class="labeInfo">
			<p>{{convention.libelle}}</p>
			<small>{{getInfoConvention(convention)}}</small>
		</div>
		<strong>{{getLabelTP(convention.estTp)}}</strong>
	</div>
</div>